import { metaobjectsEndpoint, metaobjectsEndpointAuth } from "../constants";

export const metaobjectsGetCollabs = async () => {
  const url = `${metaobjectsEndpoint}/collabs`;
  const response = await fetch(url, {
    headers: {
      Authorization: `Basic ${metaobjectsEndpointAuth}`,
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": window.location.origin,
    },
    credentials: "include",
  });

  const data = await response.json();

  return data
};
